export const IP_MODULE_KEY = 'ipplan';
